import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../NavBar/NavBar';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './App.css';

class App extends Component {
  render() {
    return (
      <div id="App">
        <NavBar />
        {this.props.children}
        <NotificationContainer />
      </div>
    );
  }
}

function mapStateToProps({ session }) {
  return {
    session
  };
}

export default connect(mapStateToProps, null)(App);
